import { RegistrationFeature } from '../../models/config/registration-feature.enum';
import { RegistrationFeatures } from '../../models/config/registration-features.type';

export const mockRegistrationFeatures: RegistrationFeatures = {
  [RegistrationFeature.AccordionCustomContent]: false,
  [RegistrationFeature.ApplianceDetailsSteppedForm]: false,
  [RegistrationFeature.ApplianceSpecificContent]: false,
  [RegistrationFeature.CanRemoveApplianceRegistration]: false,
  [RegistrationFeature.ExtraYearsWarrantyMessage]: false,
  [RegistrationFeature.PrivacyPolicyCheckbox]: false,
  [RegistrationFeature.ProtectionUpsellCheckbox]: false,
  [RegistrationFeature.ProtectionUpsellPage]: false,
  [RegistrationFeature.SendRegistriaOrderInfo]: false,
  [RegistrationFeature.SeoNoIndexMetaTag]: false,
};
